export const dateSuffix = (d: number) => {
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const getDayDiff = (a: Date, b: Date) => {
  const diffTime = Math.abs(b.getTime() - a.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const formatReportDate = (reportDate: Date) => {
  return `${monthNames[reportDate.getMonth()]} ${reportDate.getFullYear()}`;
};
export const getCurrentAndPrevMonths = (
  day: number,
  month: number,
  year: number
) => {
  const endDate = new Date(year, month, day);
  const startDate = new Date(year, month === 0 ? 11 : month - 1, day);
  return { endDate, startDate };
};

export interface DateInfo {
  display: string;
  month: number;
  year: number;
}

export const dateInfoToDate = (dateInfo: DateInfo, reportingDate: number) => {
  return new Date(dateInfo.year, dateInfo.month, reportingDate);
};

export const getMonthDiff = (datFrom: Date, datTo: Date): DateInfo[] => {
  const arr: DateInfo[] = [];
  const fromYear = 2023; //datFrom.getFullYear();
  const toYear = 2023; //datTo.getFullYear();
  const diffYear = 12 * (toYear - fromYear) + 4; //datTo.getMonth();
  for (let i = 4; i <= diffYear; i++) {
    arr.push({
      display: monthNames[i % 12] + " " + Math.floor(fromYear + i / 12),
      month: 1 % 12,
      year: Math.floor(fromYear + i / 12),
    } as DateInfo);
  }

  return arr;
};

export const getNextOccurrenceDate = (dayOfMonth: number) => {
  // Get today's date
  const today = new Date();

  // Get the current month and year
  const month = today.getMonth();
  const year = today.getFullYear();

  // Get the next occurrence of the dayOfMonth
  const nextDate = new Date(year, month, dayOfMonth);
  if (nextDate < today) {
    // If the next occurrence has already passed this month,
    // add a month to the date to get the next occurrence.
    nextDate.setMonth(month + 1);
  }

  return nextDate;
};

export const getISOString = (date: Date): string => {
  const d = new Date(date),
    year = "" + d.getFullYear();

  let month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    hours = "" + d.getHours(),
    minutes = "" + d.getMinutes(),
    seconds = "" + d.getSeconds();
  month = month.length < 2 ? "0" + month : month;
  day = day.length < 2 ? "0" + day : day;
  hours = hours.length < 2 ? "0" + hours : hours;
  minutes = minutes.length < 2 ? "0" + minutes : minutes;
  seconds = seconds.length < 2 ? "0" + seconds : seconds;
  return (
    [year, month, day].join("-") +
    "T" +
    [hours, minutes, seconds].join(":") +
    ".000"
  );
};

export const getDaysDiff = (start: Date, end: Date) => {
  const diff = Math.abs(end.getTime() - start.getTime());
  return Math.ceil(diff / (1000 * 3600 * 24));
};

export const timeSince = (date: Date) => {
  const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
};
